// @flow

import React from "react";
import Button from "@material-ui/core/Button";
import Typography from "@material-ui/core/Typography";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogActions from "@material-ui/core/DialogActions";
import { useAnalytics, useFunctions } from "reactfire";
import { useHistory } from "react-router-dom";
import { useSnackbar } from "notistack";
import { LinearProgress } from "@material-ui/core";

type Props = {
  gameId: string,
};
function TicketCancellation({ gameId }: Props) {
  const functions = useFunctions();
  const analytics = useAnalytics();
  const { enqueueSnackbar } = useSnackbar();
  const history = useHistory();
  const [open, setOpen] = React.useState(false);
  const [loading, setLoading] = React.useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const cancelTicket = async () => {
    setLoading(true);
    const cancelTicketReservation = functions.httpsCallable(
      "cancelTicketReservation"
    );
    await cancelTicketReservation({ gameId })
      .then(() => {
        analytics.logEvent("refund");

        setOpen(false);
        enqueueSnackbar("Ticket storniert", { variant: "success" });
        return history.push("/profile");
      })
      .catch((error) => {
        enqueueSnackbar(error.message, { variant: "error" });
        console.error(error);
      });
    setLoading(false);
  };

  return (
    <Typography align={"center"}>
      <Button onClick={handleClickOpen} color={"secondary"}>
        Ticket stornieren
      </Button>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          Tickets wirklich stornieren?
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Dies lässt sich nicht rückgängig machen. Du kannst stattdessen
            ebenfalls deine Reservierung bearbeiten oder nachträglich noch
            Begleitungen hinzufügen.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          {loading ? (
            <LinearProgress style={{ width: "100%" }} />
          ) : (
            <>
              <Button onClick={handleClose} color="primary" autoFocus>
                Abbrechen
              </Button>
              <Button onClick={cancelTicket} color="secondary">
                Stornieren
              </Button>
            </>
          )}
        </DialogActions>
      </Dialog>
    </Typography>
  );
}

export default TicketCancellation;
